// extracted by mini-css-extract-plugin
export default {"Main__Btn":"ImgSlider_Main__Btn__fTOwf","image__container":"ImgSlider_image__container__l44tp","goRight":"ImgSlider_goRight__qWkdA","goLeft":"ImgSlider_goLeft__msyKt"};